import { reportScheduleConstants } from '../constants/reportSchedule.constants';

export function reportSchedule(state = {}, action) {
  switch (action.type) {
    case reportScheduleConstants.CREATE_REQUEST:
    case reportScheduleConstants.UPDATE_REQUEST:
    case reportScheduleConstants.FETCH_REQUEST:
    case reportScheduleConstants.GET_REQUEST:
    case reportScheduleConstants.REMOVE_REQUEST:
    case reportScheduleConstants.RUN_REQUEST:
      return {
        ...state,
        loading: true
      };
    case reportScheduleConstants.CREATE_SUCCESS:
    case reportScheduleConstants.GET_SUCCESS:
    case reportScheduleConstants.UPDATE_SUCCESS:
      return {
        ...state,
        schedule: action.schedule,
        loading: false
      };
    case reportScheduleConstants.FETCH_SUCCESS:
      return {
        ...state,
        schedules: action.schedules,
        loading: false
      };
    case reportScheduleConstants.REMOVE_SUCCESS:
    case reportScheduleConstants.RUN_SUCCESS:
      return {
        ...state,
        loading: false
      };
    case reportScheduleConstants.CREATE_FAILURE:
    case reportScheduleConstants.FETCH_FAILURE:
    case reportScheduleConstants.GET_FAILURE:
    case reportScheduleConstants.REMOVE_FAILURE:
    case reportScheduleConstants.UPDATE_FAILURE:
    case reportScheduleConstants.RUN_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    default:
      return state
  }
}
